module.exports = __webpack_public_path__ + "static/media/home-02.16ec1fc.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/videos/home-02.mp4
// module id = stI9
// module chunks = 1